import React from "react";
import { Typography } from "@material-ui/core";
import './Graph.css';

export default function LegendItem(props) {
    const {
        text,
        color,
        disabled,
        onClick,
        compare,
        clickable = true   
    } = props;

    const cursorStyle = clickable ? "pointer" : "default";
    
    const handleClick = () => {
        if (clickable) {
            onClick();
        }
    };

    return (
        <div 
            className="legend-object" 
            onClick={handleClick}
            style={{ cursor: cursorStyle }}
        >
            <span className="dot" style={{ backgroundColor: disabled ? "gray" : color }}></span>
            <Typography 
                variant='subtitle1' 
                style={{ color: disabled ? "gray" : color, paddingLeft: "5px" }}
            >
                {text}
            </Typography>
        </div>
    );
}